<div class="w-full h-full flex justify-center items-center">
    <section class="not-found-section">
        <img src="assets/icons/Page_not_found.png" alt="Access Denied">
        <h3>Page Not Found</h3>
        <p>Oops! The page you're looking for doesn't exist.</p>
        <div class="text-center mt-5 ml-10">
            <button mat-flat-button color="primary" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>
        </div>
    </section>
</div>